class TabsSection extends HTMLElement {
  constructor() {
    super();
    this.tabs      = this.querySelectorAll('[data-tab]');
    this.images    = this.querySelectorAll('[data-tab-image]');
    this.contentEl = this.querySelector('.tabs-section__content');
    this.bindEvents();
  }

  connectedCallback() {

    this.updateMobileImage();
    window.addEventListener('resize', () => this.updateMobileImage());
  }

  bindEvents() {
    this.tabs.forEach(tab => {
      tab.addEventListener('click', () => this.switchTab(tab));
    });
  }

  async switchTab(selectedTab) {
    const tabId        = selectedTab.dataset.tab;
    const currentImage = this.querySelector('[data-tab-image].active');
    const nextImage    = this.querySelector(`[data-tab-image="${tabId}"]`);

    this.tabs.forEach(tab => tab.classList.remove('active'));
    selectedTab.classList.add('active');
    // Fade out the old image
    if (currentImage) {
      currentImage.style.transition = 'opacity 0.3s ease-out';
      currentImage.style.opacity    = '0';
      await new Promise(r => setTimeout(r, 300));
      currentImage.classList.remove('active');
    }

    // Fade in the new one
    if (nextImage) {
      this.images.forEach(img => img.classList.remove('active'));
      nextImage.classList.add('active');      nextImage.style.opacity    = '0';
      nextImage.offsetHeight; // force reflow
      nextImage.style.transition = 'opacity 0.3s ease-in';
      nextImage.style.opacity    = '1';
    }

    this.updateMobileImage(selectedTab);
  }

  updateMobileImage(clickedTab = null) {
    // remove old clones
    this.contentEl
        .querySelectorAll('.tabs-section__mobile-image')
        .forEach(node => node.remove());

    // only on mobile
    if (window.innerWidth > 749) return;

    // pick the desktop-active image, or default to the first
    let activeImage = this.querySelector('.tabs-section__image.active');
    if (!activeImage) activeImage = this.images[0];
    if (!activeImage) return;

    const mobileClone = activeImage.cloneNode(true);
    mobileClone.classList.add('tabs-section__mobile-image');
    mobileClone.style.transition = '';
    mobileClone.style.opacity    = '';

    // insert before clickedTab if given, otherwise before the true .active
    const tabToInject =
        clickedTab ||
        this.contentEl.querySelector('.tabs-section__tab.active') ||
        this.tabs[0];

    if (tabToInject && tabToInject.parentNode) {
      tabToInject.parentNode.insertBefore(mobileClone, tabToInject);
    } else {
      const tabsList = this.contentEl.querySelector('.tabs-section__tabs');
      tabsList && tabsList.parentNode.insertBefore(mobileClone, tabsList);
    }
  }
}

customElements.define('tabs-section', TabsSection);